// extracted by mini-css-extract-plugin
module.exports = {"Form":"AuthForm_Form__2Bbgu","Logo":"AuthForm_Logo__2q-_V"};